import axios from "axios";

export const createSession = async (setSessionInfo) => {
	try {
		// Define persistentChanges and fileId
		const persistentChanges = true; // or false, depending on your needs
		const filename = process.env.REACT_APP_MODEL_FILENAME; // Ensure this is set in your environment variables
		console.info("[excel] createSession started", {
			filenamePresent: Boolean(filename),
			filenameLength: filename ? filename.length : 0,
		});

		// Validate fileId
		if (!filename) {
			console.error("[excel] REACT_APP_MODEL_FILENAME is not set in the frontend build environment.");
			return; // Exit the function if fileId is not set
		}

		// Call the backend API to create a session
		const response = await axios.post("/api/spreadsheets/create_session", {
			persistentChanges: persistentChanges,
			filename: filename,
		}, {
			headers: {
				'Content-Type': 'application/json' // Set the Content-Type header
			}
		});

		// Extract the sessionId from the response
		const sessionId = response.data.sessionId;
		console.info("[excel] createSession succeeded", {
			sessionIdPresent: Boolean(sessionId),
		});
		setSessionInfo({
			sessionId: sessionId,
		});

	} catch (error) {
		if (error.response) {
			console.error("[excel] createSession failed with backend response", {
				status: error.response.status,
				data: error.response.data,
			});
			// Handle specific error cases or show a user-friendly message
		} else {
			console.error("[excel] createSession failed before backend response", error.message);
		}
	}
};

export const readValues = async (sessionInfo, setCellValues, sheet, range) => {

	try {
		// Prepare the request body
		const requestBody = {
			sheetId: sheet,
			sessionInfo: sessionInfo.sessionId,
			range: range,
			filename: process.env.REACT_APP_MODEL_FILENAME
		};
		console.info("[excel] readValues started", {
			sheet,
			range,
			filenamePresent: Boolean(requestBody.filename),
			sessionIdPresent: Boolean(requestBody.sessionInfo),
		});

		// Make a POST request to the backend
		const response = await fetch('/api/spreadsheets/get_value', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(requestBody),
		});

		// Check for a successful response
		if (!response.ok) {
			const errorBody = await response.text();
			console.error("[excel] readValues backend returned an error", {
				status: response.status,
				statusText: response.statusText,
				body: errorBody,
			});
			throw new Error(`Error: ${response.statusText}`);
		}

		// Get the response data
		const cellResponse = await response.json();
		console.info("[excel] readValues succeeded", {
			sheet,
			range,
			rowCount: Array.isArray(cellResponse.text) ? cellResponse.text.length : 0,
		});

		// Set the cell values
		setCellValues(cellResponse.text);
	} catch (error) {
		console.error("[excel] readValues failed", error);
		setCellValues([]); // Clear values or handle error appropriately
	}

};

export const setValue = async (sessionInfo, sheet, row, column, value) => {


	try {
		const data = {
			sheetId: sheet,
			sessionInfo: sessionInfo.sessionId,
			column: column,
			row: row,
			filename: process.env.REACT_APP_MODEL_FILENAME,
			values: value
		};
		console.info("[excel] setValue started", {
			sheet,
			row,
			column,
			filenamePresent: Boolean(data.filename),
			sessionIdPresent: Boolean(data.sessionInfo),
		});

		// Call the backend API to set the cell value
		const response = await axios.post("/api/spreadsheets/set_value", data);


		console.info("[excel] setValue succeeded", response.data);

	} catch (error) {
		console.error("[excel] setValue failed", error);
		// Handle errors as necessary, e.g., show an error message to the user
	}
};

export const keepSessionAlive = async (sessionInfo, sheet) => {


	try {
		const data = {
			filename: process.env.REACT_APP_MODEL_FILENAME, // Assuming this is the fileId you need
			sheetId: sheet,
			sessionId: sessionInfo.sessionId,
		};
		console.info("[excel] keepSessionAlive started", {
			sheet,
			filenamePresent: Boolean(data.filename),
			sessionIdPresent: Boolean(data.sessionId),
		});

		// Call the backend API to keep the session alive
		const response = await axios.post("/api/spreadsheets/keep_session_alive", data);

		console.info("[excel] keepSessionAlive succeeded", response.data);
	} catch (error) {
		console.error("[excel] keepSessionAlive failed", error);
		// Handle errors as necessary, e.g., show an error message to the user
	}
};
